import Referral from '../ui/Referral';
import { connect } from 'react-redux';
import { referralSubmit, skipSubmit, goBack } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    profileElements: state.profileElements,
    referralProgram: state.referralProgram,
    requiredFields: state.requiredFields
  });

const mapDispatchToProps = dispatch =>
  ({
    onReferralSubmit(payload) {
       dispatch(
         referralSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Referral);

export default Container;
